import { BaseModel } from '@tcc-mono/shared/data-access';
import { OptionType } from '@tcc-mono/vandijk/shared/data-access/enums'

export interface Option extends BaseModel {
  id: string;
  type: OptionType;
  value: string
}
